/**
 * Plants API
 * Plant management and status endpoints
 */

import { apiClient } from "./client";
import type { PlantStatus } from "./types";

/**
 * Get list of all plants with current status
 */
export async function getPlants(): Promise<PlantStatus[]> {
  return apiClient.get<PlantStatus[]>("/api/v1/plants/");
}

/**
 * Get a specific plant by ID
 */
export async function getPlant(plantId: number): Promise<PlantStatus> {
  return apiClient.get<PlantStatus>(`/api/v1/plants/${plantId}`);
}
